// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".over-artist[data-v-bde9931a]{position:fixed;top:50%;left:50%;width:1000%;text-align:center;-webkit-transform:translate3d(-50%, -50%, 0);transform:translate3d(-50%, -50%, 0);font-size:3vw;pointer-events:none;color:#000}.grid-element[data-v-bde9931a]{-webkit-transition:opacity .5s cubic-bezier(0.455, 0.03, 0.515, 0.955);transition:opacity .5s cubic-bezier(0.455, 0.03, 0.515, 0.955)}.grid-element.deselected[data-v-bde9931a]{opacity:.4}", ""]);
// Exports
module.exports = exports;
